module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/btn-english-download.7fef6f1d.png";